module.exports = __webpack_public_path__ + "static/media/floorballfun.1fa7d7a7.jpg";